module.exports = __webpack_public_path__ + "static/media/patientIcon.c2c9b4ca.svg";